/**
 * @module common
 * @name crmService
 * @type service
 * @description Servicio para aplicar lógica de Massimo Dutti Feel a la aplicación
 */
(function () {
    'use strict';

    angular.module('itxApp.legacy').factory('crmService', crmService);

    crmService.$inject = [
        'CommonServices'
    ];

    function crmService(
        CommonServices
    ) {

        var service = {
            is360: CommonServices.is360,
        };

        return service;

    }
})();
